import { render, staticRenderFns } from "./MoneyLabel.vue?vue&type=template&id=49edac8a&scoped=true"
import script from "./MoneyLabel.vue?vue&type=script&lang=js"
export * from "./MoneyLabel.vue?vue&type=script&lang=js"
import style0 from "./MoneyLabel.vue?vue&type=style&index=0&id=49edac8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49edac8a",
  null
  
)

export default component.exports